import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import InfoBox from "components/InfoBox/InfoBox";
import axios from "axios";
import fallback from "assets/images/fallbackImg.png";
import { Article } from "interfaces/websiteContent";

interface Props {
  currentArticleId?: number;
}

const ArticleCards: React.FC<Props> = ({ currentArticleId }) => {
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    axios.get<Article[]>("/website-contents/articles/").then(response => {
      setArticles(response.data?.filter(article => article.show_on_frontpage));
    });
  }, [currentArticleId]);

  if (!articles) return null;
  return (
    <>
      <Row justify="center" style={{ width: "100vw", margin: 0 }} gutter={[48, 48]}>
        {articles
          .filter(article => article.id !== currentArticleId)
          .slice(0, 3)
          .map(article => (
            <Col key={article.id}>
              <InfoBox
                imageLink={article.big_image ?? fallback} // TODO show correct image!
                imageAlt=""
                title={article.title}
                text={`${article.content.slice(0, 100)}...`}
                buttonText="Les mer"
                buttonUrlLink={`/articles/${article.id}`}
                downloadable={false}
              />
            </Col>
          ))}
      </Row>
    </>
  );
};

export default ArticleCards;
